(function () {
  "use strict";
  var root = document.querySelector(".ccshop7");
  if (!root || root.dataset.ccShopPurchaseReady === "true") return;
  root.dataset.ccShopPurchaseReady = "true";

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  var buyTarget = root.querySelector('[data-ccshop7-buy-target="main"]');
  root.querySelectorAll("[data-ccshop7-scroll-buy]").forEach(function (trigger) {
    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      if (!buyTarget) return;
      var buyCard = buyTarget.closest(".ccshop7-buy-card") || buyTarget;
      buyCard.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: "center" });
      buyCard.classList.add("ccshop7-buy-focus");
      window.setTimeout(function () { buyCard.classList.remove("ccshop7-buy-focus"); }, 2100);
      var quantity = buyTarget.querySelector('input[name="quantity"]');
      if (quantity) window.setTimeout(function () { quantity.focus(); }, prefersReducedMotion() ? 0 : 500);
    });
  });

  if (buyTarget) {
    var variantTitle = buyTarget.getAttribute("data-ccshop7-variant-title") || "selected";
    var quantity = buyTarget.querySelector('input[name="quantity"]');
    var decrement = buyTarget.querySelector("[data-ccshop7-quantity-decrement]");
    var increment = buyTarget.querySelector("[data-ccshop7-quantity-increment]");
    var quantityStatus = buyTarget.querySelector("[data-ccshop7-quantity-status]");
    var quantityPresets = Array.prototype.slice.call(
      buyTarget.querySelectorAll("[data-ccshop7-quantity-preset]")
    );
    function numericAttribute(name, fallback) {
      if (!quantity) return fallback;
      var raw = quantity.getAttribute(name);
      var parsed = Number(raw);
      return raw !== null && raw !== "" && Number.isFinite(parsed) ? parsed : fallback;
    }
    var minimum = numericAttribute("min", 1);
    var maximum = numericAttribute("max", Infinity);
    var incrementBy = Math.max(1, numericAttribute("step", 1));
    function normalize(value) {
      var parsed = Number(value);
      if (!Number.isFinite(parsed)) parsed = minimum;
      var aligned = minimum + Math.round((parsed - minimum) / incrementBy) * incrementBy;
      return Math.min(maximum, Math.max(minimum, aligned));
    }
    function dispatchQuantityEvents() {
      quantity.dispatchEvent(new Event("input", { bubbles: true }));
      quantity.dispatchEvent(new Event("change", { bubbles: true }));
    }
    function subscriptionIsSelected() {
      var choice = buyTarget.querySelector("[data-ccshop7-selling-plan-choice]:checked");
      return Boolean(choice && choice.value);
    }
    function updateQuantityUi(value, announce) {
      var current = normalize(value);
      quantity.value = String(current);
      if (decrement) decrement.disabled = current <= minimum;
      if (increment) increment.disabled = current >= maximum;
      quantityPresets.forEach(function (preset) {
        var presetValue = Number(preset.getAttribute("data-ccshop7-quantity-preset"));
        var valid = Number.isFinite(presetValue)
          && presetValue >= minimum
          && presetValue <= maximum
          && (presetValue - minimum) % incrementBy === 0;
        preset.disabled = !valid;
        preset.setAttribute("aria-pressed", String(valid && presetValue === current));
      });
      if (quantityStatus && announce !== false) {
        var bottleWord = current === 1 ? "bottle" : "bottles";
        var unitWord = current === 1 ? "unit" : "units";
        quantityStatus.textContent = current + " " + bottleWord
          + " selected. Add to cart will add " + current + " " + unitWord
          + " of the " + variantTitle + " item."
          + (subscriptionIsSelected() ? " This count repeats with each scheduled delivery." : "");
      }
      return current;
    }
    function setQuantity(value, shouldDispatch) {
      var current = updateQuantityUi(value, true);
      if (shouldDispatch) dispatchQuantityEvents();
      return current;
    }
    if (decrement && quantity) decrement.addEventListener("click", function () {
      setQuantity(normalize(quantity.value) - incrementBy, true);
    });
    if (increment && quantity) increment.addEventListener("click", function () {
      setQuantity(normalize(quantity.value) + incrementBy, true);
    });
    quantityPresets.forEach(function (preset) {
      preset.addEventListener("click", function () {
        setQuantity(preset.getAttribute("data-ccshop7-quantity-preset"), true);
      });
    });
    if (quantity) quantity.addEventListener("change", function () {
      setQuantity(quantity.value, false);
    });

    var sellingPlanFieldset = buyTarget.querySelector("[data-ccshop7-selling-plans]");
    var sellingPlanInput = buyTarget.querySelector("[data-ccshop7-selling-plan-input]");
    var sellingPlanStatus = buyTarget.querySelector("[data-ccshop7-plan-status]");
    var sellingPlanChoices = buyTarget.querySelectorAll("[data-ccshop7-selling-plan-choice]");
    var addButton = buyTarget.querySelector("[data-ccshop7-add-button]");
    if (sellingPlanFieldset) {
      sellingPlanFieldset.hidden = false;
      sellingPlanFieldset.disabled = false;
    }
    function syncSellingPlan() {
      var selected = buyTarget.querySelector("[data-ccshop7-selling-plan-choice]:checked");
      if (!selected || !sellingPlanInput) return;
      sellingPlanInput.value = selected.value || "";
      sellingPlanInput.disabled = !selected.value;
      if (addButton && !addButton.disabled) {
        addButton.textContent = selected.value
          ? addButton.getAttribute("data-ccshop7-subscription-label")
          : addButton.getAttribute("data-ccshop7-one-time-label");
      }
      if (sellingPlanStatus) {
        sellingPlanStatus.textContent = (selected.getAttribute("data-ccshop7-plan-label") || "Purchase option") + " selected.";
      }
      if (quantity) updateQuantityUi(quantity.value, true);
    }
    sellingPlanChoices.forEach(function (choice) { choice.addEventListener("change", syncSellingPlan); });
    if (quantity) updateQuantityUi(quantity.value, false);
    syncSellingPlan();
  }
})();

(function () {
     var gallery = document.querySelector("[data-ccshop7-product-gallery]");
     if (!gallery || gallery.dataset.ccShopGalleryReady === "true") {
       return;
     }
     var stage = gallery.querySelector("[data-ccshop7-gallery-stage]");
     var slides = Array.prototype.slice.call(
       gallery.querySelectorAll("[data-ccshop7-gallery-slide]")
     );
     var thumbs = Array.prototype.slice.call(
       gallery.querySelectorAll("[data-ccshop7-gallery-thumb]")
     );
     var previous = gallery.querySelector("[data-ccshop7-gallery-prev]");
     var next = gallery.querySelector("[data-ccshop7-gallery-next]");
     var current = gallery.querySelector("[data-ccshop7-gallery-current]");
     var total = gallery.querySelector("[data-ccshop7-gallery-total]");
     var lightbox = gallery.querySelector("[data-ccshop7-gallery-lightbox]");
     var lightboxImage = gallery.querySelector(
       "[data-ccshop7-gallery-lightbox-image]"
     );
     var lightboxCaption = gallery.querySelector(
       "[data-ccshop7-gallery-lightbox-caption]"
     );
     var closeLightbox = gallery.querySelector(
       "[data-ccshop7-gallery-close]"
     );
     var index = 0;
     var touchStartX = null;
     if (!slides.length) {
       return;
     }
     gallery.dataset.ccShopGalleryReady = "true";
     if (total) {
       total.textContent = String(slides.length);
     }
     function normalizeIndex(value) {
       return (value + slides.length) % slides.length;
     }
     function hydrateSlide(slide) {
       if (!slide || slide.getAttribute("data-ccshop7-hydrated") === "true") {
         return;
       }
       var image = slide.querySelector("img");
       if (image) {
         var source = image.getAttribute("data-ccshop7-src");
         var sourceSet = image.getAttribute("data-ccshop7-srcset");
         var sizes = image.getAttribute("data-ccshop7-sizes");
         if (sizes) {
           image.setAttribute("sizes", sizes);
         }
         if (sourceSet) {
           image.setAttribute("srcset", sourceSet);
         }
         if (source) {
           image.setAttribute("src", source);
         }
       }
       var galleryImage = slide.getAttribute("data-ccshop7-gallery-image");
       if (galleryImage) {
         slide.style.setProperty("--cc-gallery-image", galleryImage);
       }
       slide.setAttribute("data-ccshop7-hydrated", "true");
     }
     function showSlide(value, focusThumb) {
       index = normalizeIndex(value);
       hydrateSlide(slides[index]);
       slides.forEach(function (slide, slideIndex) {
         var isActive = slideIndex === index;
         slide.hidden = !isActive;
         slide.classList.toggle("is-active", isActive);
         slide.setAttribute("aria-hidden", isActive ? "false" : "true");
       });
       thumbs.forEach(function (thumb, thumbIndex) {
         var isActive = thumbIndex === index;
         thumb.classList.toggle("is-active", isActive);
         thumb.setAttribute("aria-selected", isActive ? "true" : "false");
         thumb.setAttribute("tabindex", isActive ? "0" : "-1");
       });
       if (current) {
         current.textContent = String(index + 1);
       }
       if (focusThumb && thumbs[index]) {
         thumbs[index].focus();
       }
     }
     function openLightbox() {
       if (!lightbox || !lightboxImage) {
         return;
       }
       var activeSlide = slides[index];
       var image = activeSlide.querySelector("img");
       var caption = activeSlide.querySelector("figcaption");
       var fallbackCaption = activeSlide.getAttribute(
         "data-ccshop7-lightbox-caption"
       );
       lightbox.classList.toggle(
         "ccshop7-product-lightbox-paper",
         activeSlide.classList.contains("ccshop7-product-slide-paper")
       );
       lightboxImage.src =
         image.getAttribute("data-ccshop7-lightbox-src") ||
         image.currentSrc ||
         image.src;
        lightboxImage.alt = image.alt || "";
        lightboxImage.width = Number(image.getAttribute("width")) || 1227;
        lightboxImage.height = Number(image.getAttribute("height")) || 1504;
       if (lightboxCaption) {
         lightboxCaption.textContent = caption
           ? caption.textContent
           : fallbackCaption || image.alt || "";
       }
       if (typeof lightbox.showModal === "function") {
         lightbox.showModal();
       } else {
         lightbox.setAttribute("open", "");
       }
     }
     function closeDialog() {
       if (!lightbox) {
         return;
       }
       if (typeof lightbox.close === "function") {
         lightbox.close();
       } else {
         lightbox.removeAttribute("open");
       }
     }
     if (previous) {
       previous.addEventListener("click", function () {
         showSlide(index - 1, false);
       });
     }
     if (next) {
       next.addEventListener("click", function () {
         showSlide(index + 1, false);
       });
     }
     thumbs.forEach(function (thumb) {
       function warmSelectedSlide() {
         var thumbIndex = parseInt(
           thumb.getAttribute("data-ccshop7-gallery-thumb"),
           10
         );
         hydrateSlide(slides[thumbIndex]);
       }
       thumb.addEventListener("click", function () {
         showSlide(
           parseInt(thumb.getAttribute("data-ccshop7-gallery-thumb"), 10),
           false
         );
       });
       thumb.addEventListener("pointerenter", warmSelectedSlide, {
         once: true
       });
       thumb.addEventListener("focus", warmSelectedSlide, {
         once: true
       });
       thumb.addEventListener("keydown", function (event) {
         var thumbIndex = parseInt(
           thumb.getAttribute("data-ccshop7-gallery-thumb"),
           10
         );
         if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
           event.preventDefault();
           showSlide(thumbIndex - 1, true);
         }
         if (event.key === "ArrowRight" || event.key === "ArrowDown") {
           event.preventDefault();
           showSlide(thumbIndex + 1, true);
         }
         if (event.key === "Home") {
           event.preventDefault();
           showSlide(0, true);
         }
         if (event.key === "End") {
           event.preventDefault();
           showSlide(slides.length - 1, true);
         }
       });
     });
     gallery
       .querySelectorAll("[data-ccshop7-gallery-zoom]")
       .forEach(function (button) {
         button.addEventListener("click", openLightbox);
       });
     if (stage) {
       stage.addEventListener("keydown", function (event) {
         if (event.key === "ArrowLeft") {
           event.preventDefault();
           showSlide(index - 1, false);
         }
         if (event.key === "ArrowRight") {
           event.preventDefault();
           showSlide(index + 1, false);
         }
         if (event.key === "Home") {
           event.preventDefault();
           showSlide(0, false);
         }
         if (event.key === "End") {
           event.preventDefault();
           showSlide(slides.length - 1, false);
         }
       });
       stage.addEventListener(
         "touchstart",
         function (event) {
           touchStartX = event.changedTouches[0].clientX;
         },
         { passive: true }
       );
       stage.addEventListener(
         "touchend",
         function (event) {
           if (touchStartX === null) {
             return;
           }
           var difference = event.changedTouches[0].clientX - touchStartX;
           touchStartX = null;
           if (Math.abs(difference) < 42) {
             return;
           }
           showSlide(difference > 0 ? index - 1 : index + 1, false);
         },
         { passive: true }
       );
     }
     if (closeLightbox) {
       closeLightbox.addEventListener("click", closeDialog);
     }
     if (lightbox) {
       lightbox.addEventListener("click", function (event) {
         if (event.target === lightbox) {
           closeDialog();
         }
       });
     }
     showSlide(0, false);
   })();
